import * as UpChunk from '@mux/upchunk';
import auth from '../auth';
import axios from 'axios';

const upload = ({ file, url, chunkSize = 5120, onProgress }) => {
  const upload = UpChunk.createUpload({
    endpoint: url,
    file: file,
    chunkSize: chunkSize,
  });
  upload.on('progress', (progress) => {
    onProgress && onProgress(progress.detail);
  });
  return upload;
};

const generateMuxSignedUrl = async ({
  influencerId,
  fileSize,
  title,
  thumbnailPosition,
  bucketName,
}) => {
  const endpoint = `${import.meta.env.VITE_MUX_API_URL}/signed-url`;
  const token = auth.getToken();
  const payload = {
    influencerId: parseInt(influencerId),
    chosenThumbnail: parseInt(thumbnailPosition),
    fileSize,
    title,
    bucketName,
  };

  try {
    const { data } = await axios.post(endpoint, payload, {
      headers: {
        Authorization: token,
      },
    });

    return data;
  } catch (error) {
    throw error;
  }
};

const fetchVideo = async (videoId) => {
  const endpoint = `${import.meta.env.VITE_MUX_API_URL}/video/${videoId}`;
  const token = auth.getToken();

  try {
    const { data } = await axios.get(endpoint, {
      headers: {
        Authorization: token,
      },
    });

    return data;
  } catch (error) {
    throw error;
  }
};

const generateStreamKey = async ({ influencerId }) => {
  const endpoint = `${import.meta.env.VITE_MUX_API_URL}/live-stream`;
  const token = auth.getToken();

  try {
    const { data } = await axios.post(
      endpoint,
      { influencerId },
      {
        headers: {
          Authorization: token,
        },
      },
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export default {
  upload,
  generateMuxSignedUrl,
  generateStreamKey,
  fetchVideo,
};

export { upload, generateMuxSignedUrl, generateStreamKey, fetchVideo };
